import React from "react";
import styles from "./index.module.scss";

type Props = {
  count: number | undefined;
  dissapearWhenZero?: boolean;
};

const CountIndicator = ({ count, dissapearWhenZero = true }: Props) => {
  if (!Boolean(count) && dissapearWhenZero) return null;
  return <div className={styles.count}>{count}</div>;
};

export default CountIndicator;
